// extracted by mini-css-extract-plugin
export default {"s_page":"Setting_s_page__O8cUB"};